import React from 'react';
import { DashboardProvider } from './DashboardContext';
import { PageProps } from '../model';

export const withDashboard = (
  PageComponent: React.ComponentType<PageProps>,
) => {
  return (props: PageProps) => (
    <DashboardProvider location={props.location}>
      <PageComponent {...props} />
    </DashboardProvider>
  );
};
